// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"64a24714","541":"20c9df5a","638":"ed8840f6","796":"2bf44fe4","867":"4c283e89","997":"9fe686ab"}[chunkId] + ".chunk.js";
};